import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const CommonDialog = ({
  open,
  title,
  message,
  onClose,
  onOk,
  okText = "OK",
  cancelText = "Cancel",
  showCancel = true,
  successFiles = [],
  ignoredFiles = [],
  acceptedPrefixes = [],
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      {title ? <DialogTitle>{title}</DialogTitle> : null}

      <DialogContent dividers>
        {message ? (
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            {message}
          </Typography>
        ) : null}
        {acceptedPrefixes && acceptedPrefixes.length > 0 ? (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="primary">
              Accepted Prefixes (Filename)
            </Typography>
            <Typography variant="body2">
              {acceptedPrefixes.join(", ")}
            </Typography>
          </Box>
        ) : null}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">
            Upload Summary
          </Typography>
          <Typography variant="body2" color="green">
            Success Count: {successFiles.length}
          </Typography>
          <Typography variant="body2" color="red">
            Ignored Count: {ignoredFiles.length}
          </Typography>
        </Box>
        {successFiles && successFiles.length > 0 ? (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="green">
              Successfully Uploaded Files
            </Typography>
            <List dense>
              {successFiles.map((file, index) => (
                <ListItem key={`success-${index}`}>
                  <ListItemText primary={file} />
                </ListItem>
              ))}
            </List>
          </Box>
        ) : null}

        {ignoredFiles && ignoredFiles.length > 0 ? (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" color="red">
              Ignored Files (Issue with naming convension)
            </Typography>
            <List dense>
              {ignoredFiles.map((file, index) => (
                <ListItem key={`ignored-${index}`}>
                  <ListItemText primary={file} />
                </ListItem>
              ))}
            </List>
          </Box>
        ) : null}
      </DialogContent>

      <DialogActions>
        {showCancel ? (
          <Button onClick={onClose} color="inherit">
            {cancelText}
          </Button>
        ) : null}
        <Button onClick={onOk} variant="contained">
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommonDialog;
